import React, { useEffect, useState } from "react";
// import IconButton from "../../components/MyActivityComponents/ButtonWithIcon";
import { Paper, Box, Typography, styled, Button } from "@mui/material";
import InfoCard from "../../components/MyActivityComponents/InfoCard";
import Cards from "../../components/MyActivityComponents/Cards";
import SelectDishes from "../../components/MyActivityComponents/Modals/SelectDishes";
import { useGetAllMealPlanQuery } from "api/Mealplans";
import { useNavigate, useParams } from "react-router";
import { useGetAllSubscriptionsQuery } from "api/subscription";
// import DailogModal from "../../components/MyActivityComponents/Modals/DailogModal"

const CustomHeading = styled(Typography)({
  fontFamily: "Outfit",
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: "40px",
  lineHeight: "140%",
  letterSpacing: "0.01em",
  color: "#FFFFFF",
  position: "absolute",
  bottom: "110px",
});

const SubTitle = styled(Typography)({
  height: "20px",
  textAlign: "start",
  fontFamily: "Outfit",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "18px",
  lineHeight: "20px",
  color: "#ffffff",
  position: "absolute",
  bottom: "90px",
});

const HeadingTypo = styled(Typography)({
  textAlign: "start",
  height: "36px",
  fontFamily: "Outfit",
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: "32px",
  lineHeight: "150%",
  marginTop: "10px",
  letterSpacing: " 0.01em",
  color: "#000000",
});

const MealPlan = () => {
  const { id } = useParams()
  console.log("paramsId", id)
  const [selectDishedModal, setSelectDishedModal] = useState(false);
  // const { data: getAllMealPlan } = useGetAllMealPlanQuery();
  // console.log("allMealPlan", getAllMealPlan)

  let navigate = useNavigate();

  let user = localStorage.getItem("user")
  user = JSON.parse(user)
  // console.log("user", user)
  // console.log("userid", user?.profile?._id)
  const { data: AllSubs, isLoading } = useGetAllSubscriptionsQuery(user?.profile?._id);
  console.log("AllSubs", AllSubs)

  const [subReq, setSubReq] = useState([])
  useEffect(() => {
    const filterReq = AllSubs?.data?.find((req) => req._id === id)
    console.log("filterReq", filterReq)
    setSubReq(filterReq)
  }, [AllSubs?.data])




  return (
    <>
      {/* <IconButton title="Back" /> */}
      <Button variant="text" onClick={() => navigate('/dashboard')} startIcon={<i className="fas fa-arrow-left" style={{ color: "#2B817B", fontSize: "12px" }}></i>}>
        Back
      </Button>
      <Paper
        style={{
          height: "544px",
          width: "100%",
          backgroundColor: "#333",
          backgroundImage: `url("https://thumbs.dreamstime.com/b/asian-food-background-various-ingredients-rustic-stone-top-view-vietnam-thai-cuisine-148762904.jpg")`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        <Box style={{ paddingLeft: "20px" }}>
          <CustomHeading>{subReq?.mealPlan?.map((meal) => (meal?.name))}</CustomHeading>
          <SubTitle>
            <i class="fa fa-tag" style={{ marginRight: "10px" }}></i>
            Starting from $50 {`{(Weekly)}`}
          </SubTitle>
        </Box>
      </Paper>

      <Box style={{ display: "flex" }}>
        <InfoCard data={subReq} />

        <Box style={{ marginLeft: "20px", width: "100%" }}>
          <HeadingTypo>Meal Plan</HeadingTypo>
          {subReq?.menu?.map((menu) => (
            console.log("menu", menu),
            <Cards
              simpleCard={true}
              hasEditButton
              data={{
                img: menu.dish.image,
                heading: menu?.dish?.mealCourseName,
                address: `${menu?.quantity} Dishes selected`,
              }}
              onEditClick={() => {
                setSelectDishedModal(true);
              }}
            />
          ))}

          {/* <Cards
            simpleCard={true}
            hasEditButton
            data={{
              img: "https://picsum.photos/200",
              heading: "Salad Dishes",
              address: "30 Dishes selected",
            }}
            onEditClick={() => {
              setSelectDishedModal(true);
            }}
          /> */}
        </Box>
      </Box>

      {selectDishedModal && (
        <SelectDishes
          onClose={() => {
            setSelectDishedModal(false);
          }}
          isOpen={true}
        />
      )}

    </>
  );
};

export default MealPlan;
